(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const clamp = (value, minimum, maximum) => Math.min(maximum, Math.max(minimum, value));

  const initRevealMotion = (scope = document) => {
    const selectors = [
      '.cc-page-hero__inner',
      '.template-collection #product-grid .grid__item',
      '.template-search #product-grid .grid__item',
      '.template-product .product__media-item',
      '.template-product .product__info-container > *',
      '.template-page #MainContent .rte > *',
      '.template-page #MainContent .multicolumn-list__item',
      '.template-list-collections .collection-list__item',
    ];

    const items = [...scope.querySelectorAll(selectors.join(','))]
      .filter((item) => !item.closest('[data-cc-home]') && !item.dataset.ccMotionReady);

    items.forEach((item, index) => {
      item.dataset.ccMotionReady = 'true';
      item.classList.add('cc-motion-reveal');
      item.style.setProperty('--cc-reveal-delay', `${Math.min(index % 4, 3) * 70}ms`);
    });

    if (reducedMotion || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries, revealObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -7% 0px', threshold: 0.06 }
    );

    items.forEach((item) => observer.observe(item));
  };

  const initPageParallax = () => {
    const heroGrid = document.querySelector('.cc-page-hero__grid');
    if (!heroGrid || reducedMotion) return;

    let frame = 0;
    const update = () => {
      frame = 0;
      const hero = heroGrid.closest('.cc-page-hero');
      const shift = clamp(-hero.getBoundingClientRect().top * 0.08, 0, 42);
      heroGrid.style.setProperty('--cc-page-hero-shift', `${shift}px`);
    };
    const requestUpdate = () => {
      if (!frame) frame = window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    update();
  };

  const initCursor = () => {
    if (reducedMotion || !finePointer || window.Shopify?.designMode || document.querySelector('.cc-cursor-dot')) return;

    const dot = document.createElement('span');
    const ring = document.createElement('span');
    dot.className = 'cc-cursor-dot';
    ring.className = 'cc-cursor-ring';
    dot.setAttribute('aria-hidden', 'true');
    ring.setAttribute('aria-hidden', 'true');
    document.body.append(dot, ring);
    document.documentElement.classList.add('cc-cursor-ready');

    let targetX = window.innerWidth / 2;
    let targetY = window.innerHeight / 2;
    let ringX = targetX;
    let ringY = targetY;
    let cursorFrame = 0;

    const render = () => {
      ringX += (targetX - ringX) * 0.2;
      ringY += (targetY - ringY) * 0.2;
      dot.style.transform = `translate3d(${targetX}px, ${targetY}px, 0) translate(-50%, -50%)`;
      ring.style.transform = `translate3d(${ringX}px, ${ringY}px, 0) translate(-50%, -50%)`;
      if (Math.abs(targetX - ringX) > 0.1 || Math.abs(targetY - ringY) > 0.1) {
        cursorFrame = window.requestAnimationFrame(render);
      } else {
        cursorFrame = 0;
      }
    };

    document.addEventListener('pointermove', (event) => {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      targetX = event.clientX;
      targetY = event.clientY;
      document.documentElement.classList.add('cc-cursor-visible');
      document.documentElement.classList.toggle(
        'cc-cursor-hover',
        Boolean(event.target.closest('a, button, summary, input, select, textarea, [role="button"]'))
      );
      if (!cursorFrame) cursorFrame = window.requestAnimationFrame(render);
    }, { passive: true });

    document.addEventListener('pointerleave', () => {
      document.documentElement.classList.remove('cc-cursor-visible', 'cc-cursor-hover');
    });
  };

  const boot = () => {
    initRevealMotion();
    initPageParallax();
    initCursor();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => initRevealMotion(event.target));
})();
